<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask
            id="mask0_20962_353215"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
        >
            <rect width="24" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_20962_353215)">
            <path
                d="M3.64247 17.3175L3.77824 16.77L3.37997 16.3706C1.8699 14.8563 1 12.973 1 10.9502C1 6.3006 5.72008 2.2002 12 2.2002C18.2799 2.2002 23 6.3006 23 10.9502C23 15.5998 18.2799 19.7002 12 19.7002C10.3236 19.7002 8.74111 19.3903 7.31769 18.8548L6.78642 18.655L6.34248 19.0087C5.46075 19.7112 3.86856 20.7462 1.77389 21.0869C1.84794 20.9848 1.92392 20.8774 2.00096 20.7652C2.59742 19.8965 3.30816 18.6654 3.64247 17.3175Z"
                stroke="white"
                stroke-width="2"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "SpeechBubbleOutlineIcon",
};
</script>
